export const TABLE_MIN_HEIGHT = 120;
export const DEFAULT_OVERSCAN = 20;
export const ESTIMATED_ROW_HEIGHT = 53;
